<template>
	<div class="content">
		<h3>下级经销商用户设置</h3>
		<div class="item">
			<el-form ref="form" :inline="true" :model="form" label-width="100px">
				<el-form-item label="用户名">
					<el-input v-model="form.username" clearble></el-input>
				</el-form-item>
				<el-form-item label="经销商">
					<el-input v-model="form.username" clearble></el-input>
				</el-form-item>
			</el-form>
			<div class="btn">
				<el-button type="primary">查 询</el-button>
                <el-button type="primary">添 加</el-button>
			</div>
		</div>
		<div class="item">
			<el-table :data="tableData" border>
				<el-table-column align="center" label="出库单号"></el-table-column>
                <el-table-column align="center" label="创建时间"></el-table-column>
				<el-table-column align="center" label="更新时间"></el-table-column>
				<el-table-column align="center" label="单据类型"></el-table-column>
				<el-table-column align="center" label="经销商"></el-table-column>
                <el-table-column align="center" label="经销商层级"></el-table-column>
				<el-table-column align="center" label="操作员"></el-table-column>
                <el-table-column align="center" label="详情"></el-table-column>
			</el-table>
			<el-pagination
                background
                @current-change="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :total="pageNum"
                :page-size="10">
                </el-pagination>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			form: {
				username: '',
				name: '',
                provice: '',
                city: '',
                region: '',
            },
            provice:[],
			Selcity:[],
			Selregion:[],

			city:[],
			region:[],

			Salescity:[],
            Salesregion:[],
            
			tableData: [],
			pageNum:0,
		}
    },
    mounted : function(){
		this.Getprovice();	
	},
    methods:{
        Getprovice(){
			this.$axios({
        		method: 'post',
        		url:'/FW/Province.ashx',
        		params: {
          			action:"getprovice"
        		}
        	}).then(res=>{
          		if(res.Code==0){
					this.provice=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})
		},

		GetSelcity(provice){
			this.$axios({
        		method: 'post',
        		url:'/FW/Province.ashx',
        		params: {
					  action:"getcity",
					  city:provice
        		}
        	}).then(res=>{
				this.form.city=''
				this.form.region=''
          		if(res.Code==0){
					this.Selcity=res.DataList
          		}else{
					this.Selcity=null
					this.Selregion=null
          		}       
      		})
		},
		GetSelregion(city){
			this.$axios({
        		method: 'post',
        		url:'/FW/Province.ashx',
        		params: {
					  action:"getregion",
					  region:city
        		}
        	}).then(res=>{
				this.form.region=''
          		if(res.Code==0){
					this.Selregion=res.DataList
          		}else{
					this.Selregion=null
          		}       
      		})
		},

		
        handleCurrentChange(){

        }
    }
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:0 100px;
}
.el-form--inline .el-form-item{
    width:300px;
}
.el-input {
	width:220px;
}
</style>


// WEBPACK FOOTER //
// src/pages/DealerUserList.vue